import localwhereclause from "../../../../src/assets/images/docs/how-to/functionalities/_localwhereclause.png";
import * as React from 'react';
export default {
  localwhereclause,
  React
};